__turbopack_context__.v({
  "info": "SectionBar-module__vWsX6a__info",
  "sectionBar": "SectionBar-module__vWsX6a__sectionBar",
  "sectionBarCard": "SectionBar-module__vWsX6a__sectionBarCard",
  "sectionBarText": "SectionBar-module__vWsX6a__sectionBarText",
  "success": "SectionBar-module__vWsX6a__success",
});
